
export class InformacionVisitanteModel {
    constructor(
        public nombreCompleto: string,
        public tipoDocumento: string,
        public numeroDocumento: string,
        public correoElectronico: string,
        public empresa: string,
        public funcionario: boolean,
        public foto: string,
        public vehiculo: any,
        public placa: string,
        public ingresoActivo: boolean,
        public pantalla: string,
        public listaVisitas: InformacionVisitaDetalle[],
        public tipoVisitante: string,
        public saleActivoFijo?: any,
        public sticker?: boolean,
        public tipoRegistro?: string,
        public ingresoVehiculo?: boolean,
        public observaciones?: string,
        public codigoTipoDocumento?: string,
        public codigoTarjeta?: string,
        public tieneActivosIngresados?: boolean,
        public tipoIdPreautorizador?: string,
        public numIdPreautorizador?: string,
        public sede?: string,
        public primerNombre?: string,
        public segundoNombre?: string,
        public primerApellido?: string,
        public segundoApellido?: string
    ) { }
}

export class InformacionVisitaDetalle {
    constructor(
        public fechaAutorizacion: string,
        public aquienVisita: string,
        public dependencia: string,
        public quienAutoriz: string,
        public extensionTelefonica?: string,
        public fecha_Inicial_Agendada?: string,
        public num_Doc_Visitante?: string,
        public numero_Id_Funcionario?: string,
        public tipo_Doc_Visitante?: string,
        public tipo_Id_Funcionario?: string,
        public tipoIdPreautorizador?: string,
        public numIdPreautorizador?: string,
        public sede?:string,
        public tipoVisita?: string
    ) { }
}
